import { Breadcrumb } from "@components/anti/Breadcrumb"
import { Cover } from "@components/anti/Cover"
import { Image } from "@components/anti/Image"
import { linkProductsServices } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { imgUrl } from "src/mixins"

export function MTixCover({ data, locale, title }) {
  return (
    <Cover
      revealEffect
      title={data && data[`title_${locale}`]}
      text=""
      img={imgUrl(data?.banner_image_mobile)}
      imgMd={imgUrl(data?.banner_image_desktop)}
      imgHeight="h-vh-100"
      className="mtix-cover"
      imgOverlay="50"
      breadcrumb={
        <Breadcrumb
          path={[
            {
              title: translations[`product_services_${locale}`],
              url: linkProductsServices,
            },
            { title: title || "m.tix" },
          ]}
          theme="dark"
        />
      }
    >
      <div className="img-barcode">
        <Image
          src={imgUrl(data?.qr_code_image)}
          className="img-fluid"
          alt="barcode"
          width="184"
          height="240"
        />
      </div>
    </Cover>
  )
}
